// import type { ReactNode } from "react"


export function Card({ children, className = "" }) {
  return <div className={`bg-white rounded-xl shadow-lg border border-gray-100 ${className}`}>{children}</div>
}

export function CardContent({ children, className = "" }) {
  return <div className={className}>{children}</div>
}
